export enum ItemType {
  SHOW = 'SHOW',
  COLLECTION = 'COLLECTION',
  CATEGORY = 'CATEGORY'
}

export interface SearchCapsuleItem {
  id: string;
  item_id?: string;
  item_type: ItemType;
  name?: string;
  thumbnail?: string;
}

export interface GroupedSearchCapsule {
  phrase: string;
  status: 'ACTIVE' | 'INACTIVE';
  items: SearchCapsuleItem[];
  createdAt: string;
  updatedAt: string;
}

export interface BulkCreatePayload {
  phrase: string;
  items: {
    item_id: string;
    item_type: ItemType;
  }[];
  status?: 'ACTIVE' | 'INACTIVE';
}

export interface SearchCapsulesResponse {
  results: GroupedSearchCapsule[];
  pages: number;
  total: number;
  pagination: {
    pageSize: number;
    pageIndex: number;
  };
  message: string;
}
